import {
  SET_CUSTOMER_ADDRESS,
  GET_CUSTOMER_SERVICES_PENDING,
  GET_HOLIDAY_SCHEDULE_FAILED,
  GET_HOLIDAY_SCHEDULE_FULFILLED,
  GET_HOLIDAY_SCHEDULE_PENDING,
  GET_HOLIDAY_SCHEDULE_RESET,
} from "constants-lib/actionTypes"

const initialState = {
  getHolidayScheduleState: ``,
  holidayData: [],
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_CUSTOMER_ADDRESS:
    case GET_CUSTOMER_SERVICES_PENDING:
      return {
        ...state,
        holidayData: [],
      }

    case GET_HOLIDAY_SCHEDULE_FAILED:
      return {
        ...state,
        holidayData: [],
        getHolidayScheduleState: `failed`,
      }

    case GET_HOLIDAY_SCHEDULE_FULFILLED:
      return {
        ...state,
        holidayData: action.payload,
        getHolidayScheduleState: `fulfilled`,
      }

    case GET_HOLIDAY_SCHEDULE_RESET:
      return {
        getHolidayScheduleState: ``,
        holidayData: [],
      }

    case GET_HOLIDAY_SCHEDULE_PENDING:
      return {
        ...state,
        getHolidayScheduleState: `pending`,
      }
    default:
      return state
  }
}
